export default "__VITE_ASSET__a70341b7__"